import VoicesCampaignList from "../Components/Voices/Campaigns/VoicesCampaignList";

const VoicesCampaignsPage = () => {
  return <VoicesCampaignList />;
};

export default VoicesCampaignsPage;
